import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';
import type { NodeSpec } from './NodeSpec';

export const materialDisassemblyUiNodeSpec: NodeSpec<NodeCfg<'materialDisassembly'>> = {
    cfg: () => ({
        kind: 'materialDisassembly',
        id: getUID(),
        controlValues: { reason: null },
    }),
    controls: nodeCfg => ({
        reason: defineControlOpts({
            cfg: { kind: 'text', label: 'Reason' },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.reason,
        }),
    }),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        material1Id: { socket: 'string', label: 'Material ID' },
        material2Id: { socket: 'string', label: 'Material ID' },
    }),
    requiredSockets: [ 'trigger', 'material1Id', 'material2Id' ],
    kindLabel: 'Material Disassembly',
    nodeCategory: 'material',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: node => node.controlValues.reason
        ? true
        : { reason: 'Reason is required' },
};
